/**
 * Helper function to format integration labels
 * Uppercases AWS, Azure, and GCP labels
 * @param {string} label - The integration label
 * @returns {string} - The formatted label
 */
export const formatIntegrationLabel = (label) => {
  if (!label) return label;
  const lowerLabel = label.toLowerCase();
  if (lowerLabel === "aws" || lowerLabel === "azure" || lowerLabel === "gcp") {
    return label.toUpperCase();
  }
  return label;
};

export const pollConnectHealth = async (
  refetch,
  integrationResourceId,
  { intervalMs = 2000, timeoutMs = 15000 } = {}
) => {
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    try {
      const result = await refetch();
      const list =
        result?.data?.getAccountDetails?.userIntegrationsDetails?.list || [];
      const rci = list.find(
        (r) => r.integration_resource_id === integrationResourceId
      );
      if (rci && rci.is_active === false) {
        return {
          status: "failed",
          inactivityReason: rci.inactivity_reason || null,
        };
      }
      if (rci && rci.is_active === true) {
      }
    } catch (err) {
      // Swallow — next tick may succeed.
    }
    await new Promise((r) => setTimeout(r, intervalMs));
  }
  return { status: "timeout" };
};
